v-container
  //- Title
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('financial.title') }}

  //- Introduction
  v-row
    v-col(cols="12")
      for text, index in $tm('financial.introduction')
        p.text-body-1.mb-3 {{ text }}

  v-divider.my-6

  //- Policy Sections
  for section, key in sections
    v-row
      v-col(cols="12")
        h3.text-h6.mb-2 {{ $t(`financial.sections.${key}.heading`) }}
        p.text-body-2 {{ $t(`financial.sections.${key}.content`) }}

    v-divider.my-4
  v-row
    v-col(cols="12")
      a(target="_blank" href="/privacy-policy") Saunders Oculoplastic Surgery Privacy Policy 

  //- Closing Statement
  v-row
    v-col(cols="12")
      p.text-body-1.font-weight-medium {{ $t('financial.closingStatement') }}

  v-divider.my-6

  //- Signature Section
  v-row
    v-col(cols="12")
      SignaturePad(
        v-model="form.signature"
        :label="$t('financial.signature')"
          :rules="[form.validCheck('signature')]"
      )
